import type { ReactNode } from 'react';
import { usePlatformFavicon } from '../hooks/usePlatformFavicon';

/** Applies the Compete Pages tab icon for all child routes (dashboard, editor, auth, etc.). */
export function PlatformFavicon({ children }: { children: ReactNode }) {
  usePlatformFavicon();
  return <>{children}</>;
}
